<template>
  <div class="container-filter">
    <div class="header-filter">
      <span v-b-toggle="'sidebar-' + filterId" class="title">{{ title }}</span>
    </div>
    <b-sidebar :id="'sidebar-' + filterId" no-header right shadow>
      <template v-slot:default="{ hide }">
        <div class="container-sidebar">
          <header
            class="b-sidebar-header d-flex w-100 justify-content-between py-3"
          >
            <h4 class="mb-0">{{ title }}</h4>
            <div class="d-flex align-items-center" style="min-width: 136px">
              <span class="borrar-filtro pe-2" @click="filterSelect = []"
                >Borrar filtro</span
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="cursor: pointer"
                width="20"
                height="20"
                viewBox="0 0 48 48"
                @click="hide"
              >
                <path
                  id="Trazado_4945"
                  data-name="Trazado 4945"
                  d="M0,0H48V48H0Z"
                  fill="none"
                />
                <g id="Shopicon">
                  <path
                    id="Trazado_4946"
                    data-name="Trazado 4946"
                    d="M8,41.414l16-16,16,16L41.414,40l-16-16,16-16L40,6.586l-16,16-16-16L6.586,8l16,16-16,16Z"
                  />
                </g>
              </svg>
            </div>
          </header>
          <div class="body-filter">
            <div
              v-for="(filter, index) in filtros"
              :key="index"
              class="container-filter-simple"
              :class="filterSelect.includes(filter.slug) ? 'selected' : ''"
              @click="addFilter(filter.slug, false)"
            >
              <p class="text-filter">
                {{
                  filter.text.toLowerCase().replace(/^\w/, d => d.toUpperCase())
                }}
              </p>
            </div>
          </div>
          <div class="btn-filter">
            <button
              class="w-100 bnt-primary"
              @click="
                addFilter('', true)
                hide
              "
            >
              Aplicar filtros
            </button>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
export default {
  props: {
    filterId: {
      type: String,
      required: true,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    filtros: {
      type: Array,
      required: false,
      default: () => [],
    },
    updateSearch: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      filterSelect: [],
      queryId: '',
    }
  },
  watch: {
    updateSearch() {
      if (this.updateSearch > 0) {
        this.addFilter('', true)
      }
    },
  },
  mounted() {
    let query = Object.assign({}, this.$route.query)
    this.queryId = this.filtros[0].query_name
    if (query[this.filtros[0].query_name]) {
      this.filterSelect = this.$route.query[this.filtros[0].query_name].split(
        ',',
      )
    }
  },
  methods: {
    addFilter(filter, action) {
      if (action) {
        let query = Object.assign({}, this.$route.query)
        console.log(query, query[this.queryId])
        if (this.filterSelect.length > 0) {
          query[this.queryId] = this.filterSelect.toString()
        }
        if (this.filterSelect.length == 0 && query[this.queryId]) {
          delete query[this.queryId]
        }
        this.$router.push({ query: query })
      } else {
        if (this.filterSelect.includes(filter)) {
          this.filterSelect = this.filterSelect.filter(item => item !== filter)
        } else {
          this.filterSelect.push(filter)
        }
      }
    },
  },
}
</script>
